import '../../App.css';
import '../../css/bootstrap.scss';
import google_icon from "../../images/google.png";
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useState, useRef } from 'react';
import config from '../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setwizardPageNumber, setFaceID } from '../LoginReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import CameraModal from '../Camera/CameraModal';
import SelfieCameraModal from '../Camera/SelfieCameraModal';
import { AxiosError } from 'axios';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import { isEmailExist, validateEmail, verifyFace, verifyFaceEnhanced, getUserID } from '../../Utils/user';

interface FormData {
    email_faceid: string;
}

interface Props { };

const FirstForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.loginAccount.wizardPageNumber);

    const faceID = useSelector((state: RootState) => state.loginAccount.faceID);
    const email = useSelector((state: RootState) => state.loginAccount.email);
    const [showModal1, setShowModal1] = useState(false);
    const modalRef1 = useRef<string | null>(null);
    const [validated, setValidated] = useState(false);

    const handleShowModal1 = () => {
        setShowModal1(true);
    };

    const handleCloseModal1 = async () => {
        setShowModal1(false);

        try {
            const userId = await getUserID(email);
            if (!userId) {
                notifyError("User ID not found");
                return;
            }

            const byteCharacters = atob(faceID);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const faceBlob = new Blob([byteArray], { type: 'image/jpeg' });

            const result = await verifyFaceEnhanced(userId, faceBlob);

            if (result.biometric === true) {
                notifySuccess("User Login Successfully");
            } else {
                notifyError(result.msg || "Verification Failed");
            }
            console.log("Verification Result:", result);

        } catch (error) {
            console.error("Error during face verification:", error);
            notifyError("An error occurred during verification");
        }
    };

    const updateSrcModal1 = (newState: any) => {
        const parts = newState.split(',');
        if (parts.length === 2) {
            const faceBase64: any = parts[1];
            dispatch(setFaceID(faceBase64));
        }
    };

    const submitFaceIDForm = async (formValues: FormData) => {
        const email = formValues.email_faceid;

        let isEmailExistResponse = await isEmailExist(email);

        if (isEmailExistResponse) {
            dispatch(setEmail(email));
            handleShowModal1();
        } else {
            notifyError("User does not exist");
        }

        setValidated(true);
    };

    return (
        <>
            <SelfieCameraModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title="Take a selfie"
                ref={modalRef1}
                side=""
                updateSrc={updateSrcModal1}
            />
            <ToastBox />
            <Form noValidate={true} onSubmit={handleSubmit(submitFaceIDForm)}>
                <Row className='mt-5'>
                    <label className="form-label mb-3">{t('login.email_phone')}</label>

                    <Field
                        name="email_faceid"
                        type="email"
                        component={renderField}
                        className="form-control rounded-5 py-2"
                        placeholder={t('login.enter_email')}
                        id="email_faceid"
                        validate={validateEmail}
                        required
                    />
                </Row>

                <Row className=''>
                    <Col md={6} className='py-4'>
                        <Button type='submit' className='btn btn-primary px-4 py-2  mt-3 rounded-5'>{t('login.open_faceid')}</Button>
                    </Col>
                    <Col md={6} className='py-5'>
                        <Link to={'/ResetPassword'} className=''>{t('login.forgot')}</Link>
                    </Col>
                </Row>

                <Row className='py-1'>
                    <div className="col-md-12 d-flex align-items-center justify-content-center">
                        <hr className="flex-grow-1 mx-4" />
                        <div className="centered-text text-secondary">{t('login.or_continue')}</div>
                        <hr className="flex-grow-1 mx-4" />
                    </div>
                </Row>
                <Row className='mt-3'>
                    <Col md={6}>
                        <Button
                            className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                            style={{ border: '1px solid #C5CCD6' }}
                        >
                            <img src={google_icon} style={{ width: '20px' }} />
                            &nbsp;
                            <span className='small'>{t('login.google')}</span>
                        </Button>
                    </Col>
                    <Col md={6}>
                        <Button
                            className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                            style={{ border: '1px solid #C5CCD6' }}
                        >
                            <i className="fa-brands fa-apple" style={{ fontSize: '21px' }} ></i>
                            &nbsp; &nbsp;
                            <span className='small'>{t('login.apple')}</span>
                        </Button>
                    </Col>
                </Row>
                <Row className='text-center mt-5 mb-5'>
                    <span>{t('login.no_account_q')} <Link className='text-primary' to={"/"}>{t('login.register_link')}</Link></span>
                </Row>
            </Form>
        </>
    );
};


const mapStateToProps = (state: RootState) => ({
    initialValues: {
        email_faceid: '',
    },
});

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizardFirst',
    enableReinitialize: true,
})(FirstForm);

export default connect(mapStateToProps)(form);
